import axios from "axios";
import qs from "qs";
import config from "../config";

axios.defaults.headers.common["Authorization"] = localStorage.authToken;

export default {
  detail({ table, field, id }) {
    return axios.post(
      config.endpoint + "/row/" + table + "/" + id,
      qs.stringify({
        table,
        filters: [{ type: 1, name: field, value: id }],
        id,
      })
    );
  },
  detailTable({ table }) {
    return axios.post(config.endpoint + "/table/" + table);
  },
  getNextLead(data, id) {
    return axios.post(config.endpoint + "/nextLead/" + id, qs.stringify(data));
  },

  getFavorites() {
    return axios.get(config.endpoint + "/favorites");
  },
  getAutoCompleteKeys(table, field, query) {
    return axios.get(
      config.endpoint + "/autocomplete/" + table + "/" + field + "?q=" + query
    );
  },
  clickShowLog(table, key, id) {
    return axios.post(
      config.endpoint + "/hidden/" + table + "/" + key + "/" + id
    );
  },
  addFavorite(data) {
    return axios.post(config.endpoint + "/favorites", qs.stringify(data));
  },
  mt5: {
    createPlatform(data) {
      return axios.post(config.endpoint + "/mt5/createPlatform", data);
    },
    getUserOpenPositions(data) {
      return axios.post(config.endpoint + "/mt5/getUserOpenPositions", data);
    },
    getUserPendingOrders(data) {
      return axios.post(config.endpoint + "/mt5/getUserPendingOrders", data);
    },
    getUserClosedPositions(data) {
      return axios.post(config.endpoint + "/mt5/getUserClosedPositions", data);
    },
    getUserDeposit(data) {
      return axios.post(config.endpoint + "/mt5/getUserDeposit", data);
    },
    getUserWithdrawal(data) {
      return axios.post(config.endpoint + "/mt5/getUserWithdrawal", data);
    },
    createWithdrawal(data) {
      return axios.post(config.endpoint + "/mt5/createWithdrawal", data);
    },
    createDeposit(data) {
      return axios.post(config.endpoint + "/mt5/createDeposit", data);
    },
    getPlatformInfo(data) {
      return axios.post(config.endpoint + "/mt5/getPlatformInfo", data);
    },
  },
  transaction: {
    changeStatus(id, data) {
      return axios.post(
        config.endpoint + "/transaction/changeStatus/" + id,
        qs.stringify(data)
      );
    },
    changeComment(id, data) {
      return axios.post(
        config.endpoint + "/transaction/changeComment/" + id,
        qs.stringify(data)
      );
    },
    deliveryIban(id, data) {
      return axios.post(
        config.endpoint + "/transaction/deliveryIban/" + id,
        qs.stringify(data)
      );
    },
    depositOk(id, data) {
      return axios.post(
        config.endpoint + "/transaction/depositOk/" + id,
        qs.stringify(data)
      );
    },
    leadInfo(id, trx) {
      return axios.post(
        config.endpoint + "/transaction/leadInfo?trx=" + trx,
        qs.stringify({ id })
      );
    },
    searchTrx(data) {
      return axios.post(config.endpoint + "/searchTrx", qs.stringify(data));
    },
    depositCanceled(id, data) {
      return axios.post(
        config.endpoint + "/transaction/depositCanceled/" + id,
        qs.stringify(data)
      );
    },
    riskOk(id, data) {
      return axios.post(
        config.endpoint + "/transaction/riskOk/" + id,
        qs.stringify(data)
      );
    },
    riskOkWithdrawal(id, data) {
      return axios.post(
        config.endpoint + "/transaction/riskOkWithdrawal/" + id,
        qs.stringify(data)
      );
    },
    finansOkWithdrawal(id, data) {
      return axios.post(
        config.endpoint + "/transaction/finansOkWithdrawal/" + id,
        qs.stringify(data)
      );
    },
    riskCanceled(id, data) {
      return axios.post(
        config.endpoint + "/transaction/riskCanceled/" + id,
        qs.stringify(data)
      );
    },
    riskBlocked(id, data) {
      return axios.post(
        config.endpoint + "/transaction/riskBlocked/" + id,
        qs.stringify(data)
      );
    },
    depositBlocked(id, data) {
      return axios.post(
        config.endpoint + "/transaction/depositBlocked/" + id,
        qs.stringify(data)
      );
    },
  },
  removeFavorite(id) {
    return axios.post(config.endpoint + "/favorite/remove/" + id);
  },
  removeFavoriteFilter(id) {
    return axios.post(config.endpoint + "/favorite-filters/remove/" + id);
  },
  getlastlogin() {
    return axios.post(config.endpoint + "/customer/getlastlogin/");
  },
  getProfile() {
    return axios.post(config.endpoint + "/me");
  },
  getSidebarNotes() {
    return axios.post(config.endpoint + "/sidebarNotes");
  },
  getEquityReport() {
    return axios.post(config.endpoint + "/equityreport");
  },
  getEquityReportForLogin(login) {
    return axios.post(config.endpoint + "/equityreport/" + login);
  },
  checkCrmSync(phone) {
    return axios.post(config.endpoint + "/crmsync/" + phone);
  },
  setProfile(data) {
    return axios.post(config.endpoint + "/auth/save", qs.stringify(data));
  },
  getSearchPhone(data) {
    return axios.post(config.endpoint + "/searchPhone/", qs.stringify(data));
  },

  getAllPreferences(data) {
    return axios.post(config.endpoint + "/preferences/", qs.stringify(data));
  },
  getUtmReport(data) {
    return axios.post(config.endpoint + "/report/utm", qs.stringify(data));
  },
  getImportReports() {
    return axios.get(config.endpoint + "/import-reports");
  },
  getAgentReport(data) {
    return axios.post(config.endpoint + "/report/agent", qs.stringify(data));
  },
  getReportMonthly(data) {
    return axios.post(config.endpoint + "/reportBuilder", qs.stringify(data));
  },
  savePeriodReport(data) {
    return axios.post(
      config.endpoint + "/reportBuilder/savePeriod",
      qs.stringify(data)
    );
  },
  saveReport(data) {
    return axios.post(
      config.endpoint + "/reportBuilder/saveReport",
      qs.stringify(data)
    );
  },
  deleteReport(data) {
    return axios.post(
      config.endpoint + "/reportBuilder/deleteReport",
      qs.stringify(data)
    );
  },
  updateReport(data) {
    return axios.post(
      config.endpoint + "/reportBuilder/updateReport",
      qs.stringify(data)
    );
  },
  reportBuilderFields(data) {
    return axios.post(
      config.endpoint + "/reportBuilder/fields",
      qs.stringify(data)
    );
  },
  dublicatedLeads({ id }) {
    return axios.post(
      config.endpoint + "/getDublicatedLeads",
      qs.stringify({
        id: id,
      })
    );
  },
  answerSet(id, data) {
    return axios.post(config.endpoint + "/answerSet/" + id, qs.stringify(data));
  },
  bidSet(id, data) {
    return axios.post(config.endpoint + "/bidSet/" + id, qs.stringify(data));
  },
  questions(id) {
    return axios.post(config.endpoint + "/questions/" + id);
  },
  bids(id) {
    return axios.post(config.endpoint + "/bids/" + id);
  },
  bidDetail(lead_id, bid_id) {
    return axios.post(config.endpoint + "/bids/" + lead_id + "/" + bid_id);
  },
  files(id) {
    return axios.post(config.endpoint + "/files/" + id);
  },
  fields(table) {
    return axios.get(config.endpoint + "/fields/" + table);
  },
  getDetail(table, id) {
    return axios.post(
      config.endpoint + "/row/" + table + "/" + id,
      qs.stringify({
        table,
        id,
      })
    );
  },
  getLeadDetail(table, id, trx) {
    return axios.post(
      config.endpoint + "/row/" + table + "/" + id + "?trx=" + trx,
      qs.stringify({
        table,
        id,
      })
    );
  },
  getJournal(table, id) {
    return axios.post(
      config.endpoint + "/journal/" + table + "/" + id,
      qs.stringify({
        table,
        id,
      })
    );
  },
  getTasks(table, id) {
    return axios.post(
      config.endpoint + "/tasks/" + table + "/" + id,
      qs.stringify({
        table,
        id,
      })
    );
  },
  getOptions(field) {
    return axios.get(config.endpoint + "/getOption/" + field);
  },
  getNotifications() {
    return axios.post(config.endpoint + "/notifications");
  },  completeNotification(id) {
    return axios.post(config.endpoint + "/completeNotification/"+id);
  },
 

  getOptionList() {
    return axios.get(config.endpoint + "/getOptionList");
  },
  notes({ table, field, id }) {
    return axios.post(
      config.endpoint + "/notes/" + table,
      qs.stringify({
        table,
        filters: [{ type: 1, name: field, value: id }],
        id,
      })
    );
  },
  emails({ table, field, id }) {
    return axios.post(
      config.endpoint + "/notes/" + table,
      qs.stringify({
        table,
        filters: [{ type: 1, name: field, value: id }],
        id,
      })
    );
  },
  chatMessages({ table, field, id, page, limit }) {
    return axios.post(
      config.endpoint + "/chatMessages/" + table,
      qs.stringify({
        table,
        filters: [{ type: 1, name: field, value: id }],
        limit,
        page,
        id,
      })
    );
  },
  exportExcel(table, filters) {
    return axios({
      url: config.endpoint + "/export/" + table,
      method: "POST",
      data: filters,
    });
  },
  exportDoubleExcel(table, filters) {
    return axios({
      url: config.endpoint + "/export/double/" + table,
      method: "POST",
      data: filters,
    });
  },
  inlineSave(data) {
    return axios.post(config.endpoint + "/inline/save/", qs.stringify(data));
  }, 
  processEmail(data) {
    return axios.post(config.endpoint + "/process-email/", qs.stringify(data));
  },
  doubleCheck(data) {
    return axios({
      url: config.endpoint + "/doubleCheck/",
      method: "POST",
      data: { phones: data },
    });
  },
  questionsSave(data) {
    return axios.post(config.endpoint + "/questions/save/", qs.stringify(data));
  },
  bidsSave(data) {
    return axios.post(config.endpoint + "/bids/save/", qs.stringify(data));
  },
  getSearch(data) {
    return axios.post(config.endpoint + "/search/", qs.stringify(data));
  },
  getSuggestion(data) {
    return axios.post(config.endpoint + "/suggestion/", qs.stringify(data));
  },
  getImportTemplates() {
    return axios.post(config.endpoint + "/import/templates");
  },
  detailSave(data) {
    return axios.post(config.endpoint + "/detail/save/", qs.stringify(data));
  },
  hookSave(data) {
    return axios.post(config.endpoint + "/hooks/save/", qs.stringify(data));
  },
  convertCustomer(id, data) {
    return axios.post(
      config.endpoint + "/convertCustomer/" + id,
      qs.stringify(data)
    );
  },
  fastStatusUpdate(id, data) {
    return axios.post(
      config.endpoint + "/fastStatusUpdate/" + id,
      qs.stringify(data)
    );
  },
  makeCall(data) {
    return axios.post(config.endpoint + "/makecall", qs.stringify(data));
  },
  makeFastCall(data) {
    return axios.post(config.endpoint + "/makeFastCall", qs.stringify(data));
  },
  getCalendar() {
    return axios.post(config.endpoint + "/calendar/");
  },
  bulkSave(data) {
    return axios.post(config.endpoint + "/bulk/save/", qs.stringify(data));
  },
  getReports(data) {
    return axios.post(config.endpoint + "/reports/", qs.stringify(data));
  },
  getIbCustomers(data) {
    return axios.post(config.endpoint + "/ib/customers/", qs.stringify(data));
  },
  getIbLeads(data) {
    return axios.post(config.endpoint + "/ib/leads/", qs.stringify(data));
  },
  getCallPeriods(data) {
    return axios.post(config.endpoint + "/callperiods/", qs.stringify(data));
  },
  getIbCustomerOrders(data) {
    return axios.post(
      config.endpoint + "/ib/customer/orders/",
      qs.stringify(data)
    );
  },
  getbalance(data) {
    return axios.post(config.endpoint + "/ib/balance/", qs.stringify(data));
  },
  getbalanceinfo(data) {
    return axios.post(
      config.endpoint + "/ib/balance/info/",
      qs.stringify(data)
    );
  },
  bulkInsert(data) {
    return axios.post(config.endpoint + "/bulk/insert/", data);
  },

  firstFundReport() {
    return axios.post(config.endpoint + "/piechart/firstFund/");
  },

  fieldInsert(data) {
    return axios.post(config.endpoint + "/field/insert", qs.stringify(data));
  },
  permissionSave(data) {
    return axios.post(config.endpoint + "/permission/save/", data);
  },
  bulkRemove(data) {
    return axios.post(config.endpoint + "/bulk/remove/", qs.stringify(data));
  },
  bulkRemoveNotes(data) {
    return axios.post(
      config.endpoint + "/bulk/removeNotes/",
      qs.stringify(data)
    );
  },

  getData(data) {
    return axios.post(
      config.endpoint + "/table/" + data.table,
      qs.stringify(data)
    );
  },
  favoriFilters(data) {
    return axios.post(
      config.endpoint + "/favorite-filters/" + data.table,
      qs.stringify(data)
    );
  },
  getPlatformData(data) {
    return axios.post(
      config.endpoint + "/lead-platforms/" + data.table,
      qs.stringify(data)
    );
  },
  getAdminDashboard() {
    return axios.get(config.endpoint + "/admin/info");
  },
  getUserDashboard() {
    return axios.get(config.endpoint + "/user/info");
  },
};
